<template>
  <a-modal
    title="二维码查看"
    width="600px"
    :visible="visible"
    @ok="handleCancel"
    @cancel="handleCancel"
    centered
    :body-style="{ 'text-align': 'center'}"
    cancelText="关闭">
    <a-spin :spinning="spinning">
      <img  :src="imgSrc"  />
    </a-spin>
  </a-modal>
</template>
<script>
import {membraneGenerateQRCode,sampleBlockGenerateQRCode}  from '@/api/api.js'
export default {
  props:{
    fileType:{
      default:"membrane",
      type:String
    }
  },
  data() {
    return {
      visible:false,
      confirmLoading:false,
      imgSrc:"",
      spinning:true
    }
  },
  methods: {
    handleCancel(){
      this.visible=false
      this.imgSrc=""
    },
    open(record){
      this.visible=true;
      this.spinning=true
      switch (this.fileType) {
        case "membrane":
          membraneGenerateQRCode({
            materialCode:record.materialCode
          }).then((result) => {
            if(result.code==200){
              this.imgSrc=result.message
            }else{
              this.$message.error(result.message)
            }
          }).finally(()=>{
            this.spinning=false
          })
          break;
        case "sampleBlock":
          sampleBlockGenerateQRCode({
            materialCode:record.materialCode
          }).then((result) => {
            if(result.code==200){
              this.imgSrc=result.message
            }else{
              this.$message.error(result.message)
            }
          }).finally(()=>{
            this.spinning=false
          })
          break;
        default:
          this.$message.error("前端：找不到文件类型")
          break;
      }
      
    }
  },
}
</script>

<style>
</style>